import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import ItemsTable from "../../New/items-table";
import { NormalizedCargoItem } from "../../../../../domain/models/cargo-model";
import { LoadProductListByManyCodes } from "../../../../../domain/usecases/load-product-list-by-many-codes";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = {
  cargoItems: NormalizedCargoItem[];
  open: boolean;
  handleClose: () => void;
  loadProducts: LoadProductListByManyCodes;
};

export default function ItemsDialog(props: Props) {
  const [items, setItems] = React.useState<NormalizedCargoItem[]>([]);

  React.useEffect(() => {
    const codes: string[] = [];

    props.cargoItems.map((item) => {
      codes.push(item.eanCode);
    });

    async function fetch() {
      if (codes.length === 0) return;
      const products = await props.loadProducts.load(codes);

      props.cargoItems.map((item, index) => {
        const newItems = [...props.cargoItems];

        const match = products.find((prod) => prod.eanCode === item.eanCode);

        if (match) {
          newItems[index].productDescription = match.description;
          setItems(newItems);
        }
      });
    }

    fetch();
  }, [props.cargoItems]);

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={props.handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      maxWidth={false}
    >
      <DialogContent>
        <ItemsTable cargoItems={items} />
      </DialogContent>
    </Dialog>
  );
}
